// import { appController } from "@app/model/mc/app/AppController";
import { appController } from "@app/model";
import { Dispatcher, indexedDbUtils, teamGroupMap } from "@fanfanlo";
import { env } from "@src/confs/env";
import { matrixInit } from "@src/im/client";

export class MainController extends Dispatcher{
    async init(){
        await this.start();
    }
    async start(){
        teamGroupMap.def.gateway = env.gateway;
        matrixInit.init();
        await indexedDbUtils.init()
        await appController.init()
        
    }
}

export const mainController = new MainController()